import { Component, OnInit } from '@angular/core';
import { Subject, take, takeUntil } from "rxjs";
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { VenueService } from "../../../../services/venues/venue.service";
import { MessageService } from "primeng/api";
import { DivisionModel } from "../../../../models/divisions/division.model";

@Component({
  selector: 'app-add-or-edit-division',
  templateUrl: './add-or-edit-division.component.html',
  styleUrls: ['./add-or-edit-division.component.scss']
})
export class AddOrEditDivisionComponent  implements OnInit {

  //#region Fields
  public unsubscribe: Subject<void> = new Subject<void>();
  public divisionModel: DivisionModel = new DivisionModel();
  public errorModel: { [k: string]: any } = {};
  public spinner: boolean = false;
  public venueId: string;
  public enableEdit: boolean = false;
  public requiredFieldErrorMessage = "INFO.REQUIRED_FIELD";

  //#endregion

  //#region Constructor
  constructor(
    private config: DynamicDialogConfig,
    private ref: DynamicDialogRef,
    public dialogService: DialogService,
    private venueService: VenueService,
    private messageService: MessageService
  ) {
    if (this.config.data != undefined && this.config.data.venueId) {
      this.venueId = this.config.data.venueId;
      this.divisionModel.venueId = this.venueId;
    }
    if (this.config.data != undefined && this.config.data.division) {
      this.divisionModel = this.config.data.division;
      this.enableEdit = true;
    }
  }

  ngOnInit(): void {
  }

  //#endregion

  //#region Public Methods
  addOrUpdateDivision(model: DivisionModel, update: boolean = false) {
    this.errorModel = {};

    if (model && model.name.trim() === "") {
      this.errorModel['Name'] = this.requiredFieldErrorMessage;
    }
    if (model && model.printerName.trim() === "") {
      this.errorModel['PrinterName'] = this.requiredFieldErrorMessage;
    }

    if (Object.keys(this.errorModel).length === 0) {
      this.spinner = true;

      if (update) {
        this.venueService.updateVenueDivision(model)
          .pipe(takeUntil(this.unsubscribe))
          .subscribe({
            next: _ => {
              this.spinner = false;
              this.ref.close(true)
            },
            error: _ => {
              this.spinner = false;
              this.messageService.add({severity: 'error', summary: "System error", life: 2000});
            }
          });
      } else {
        this.venueService.addVenueDivision(model)
          .pipe(takeUntil(this.unsubscribe))
          .subscribe({
            next: _ => {
              this.spinner = false;
              this.ref.close(true)
            },
            error: _ => {
              this.spinner = false;
              this.messageService.add({severity: 'error', summary: "System error", life: 2000});
            }
          });
      }
    }
  }
  //#endregion
}
